var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import DocumentSynthesisListItem from '@declaration/components/documents/DocumentSynthesisListItem.vue';
let DocumentSynthesisList = class DocumentSynthesisList extends Vue {
};
DocumentSynthesisList = __decorate([
    Component({
        components: { DocumentSynthesisListItem },
        props: {
            documents: { type: Array, required: true },
            disabled: { type: Boolean, default: false },
        },
    })
], DocumentSynthesisList);
export default DocumentSynthesisList;
